export default "<template>\n\n  <KTextbox\n    label=\"Token\"\n    value=\"123456789\"\n    readonly\n  />\n\n</template>\n";